import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';

export const StyledTableRow = styled(TableRow, { shouldForwardProp: prop => prop !== 'noBorder' })<{
  noBorder?: boolean;
}>`
  ${({ noBorder }) => noBorder && 'td, th { border: 0 }'}

  td.MuiTableCell-root:first-of-type {
    max-width: unset !important;
    padding-left: 0;
  }

  th.MuiTableCell-root {
    background-color: transparent;
    padding-right: 0;
    padding-left: 0;
    max-width: unset !important;
  }
  td.MuiTableCell-root:last-of-type,
  th.MuiTableCell-root:last-of-type {
    padding-right: 0;
  }
`;
